document.addEventListener("DOMContentLoaded", function () {
  const carouselElement = document.querySelector('.ingredients-carousel__slider');

  // Vérifier la largeur de la fenêtre et si la classe ingredients-carousel__slider-unload-desk est présente
  function initializeFlickity() {
    if (window.innerWidth < 768 || !carouselElement.classList.contains('ingredients-carousel__slider-unload-desk')) {
      // Si on est en mobile ou que la classe n'est pas présente, on instancie Flickity
      if (!carouselElement.flickityInstance) {
        // Vérifie si Flickity n'est pas déjà instancié
        carouselElement.flickityInstance = new Flickity(carouselElement, {
          cellAlign: 'left',
          contain: true,
          autoPlay: 5000,
          prevNextButtons: false,
          wrapAround: true
        });
      }
    } else {
      // En mode desktop et la classe est présente, détruire Flickity si elle existe
      if (carouselElement.flickityInstance) {
        carouselElement.flickityInstance.destroy();
        carouselElement.flickityInstance = null;
      }
    }
  }

  // Initialiser au chargement
  initializeFlickity();

  // Réagir aux changements de taille de fenêtre
  window.addEventListener('resize', initializeFlickity);
});